import { Injectable } from '@angular/core';
import {
  parseEstablishmentId,
  parseStoredPermissionTree,
  PermissionView,
} from '../../common-files/permission-tree';

// Normalizes the logged-in operator's raw stored grants on every read. Used to
// show/hide in-screen actions when
// several roles share the same view/route but with different action permissions
// (e.g. Viewer sees bookings read-only, Operator additionally gets can_manage).
@Injectable({ providedIn: 'root' })
export class PermissionService {
  // permission names granted for a view, found by its webRoute in the tree.
  permissionsForRoute(webRoute: string): string[] {
    const tree = parseStoredPermissionTree(
      localStorage.getItem('permissions'),
      parseEstablishmentId(localStorage.getItem('activeEstablishmentId')),
    );
    const node = this.findByRoute(tree, webRoute);
    return node?.permission ?? [];
  }

  // true when the view (by webRoute) grants the given permission name.
  can(webRoute: string, permission: string): boolean {
    return this.permissionsForRoute(webRoute).includes(permission);
  }

  private findByRoute(nodes: PermissionView[], webRoute: string): PermissionView | null {
    for (const node of nodes) {
      if (node?.webRoute === webRoute) return node;
      const child = this.findByRoute(node.subview, webRoute);
      if (child) return child;
    }
    return null;
  }
}
